import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, Crown, X } from 'lucide-react';
import { Button } from '../ui/button';

export default function TrialBanner({ daysRemaining, onClose }) {
  const navigate = useNavigate();

  if (daysRemaining === null || daysRemaining === undefined) return null;

  const isExpiringSoon = daysRemaining <= 2;
  const isExpired = daysRemaining === 0;

  if (isExpired) {
    return (
      <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white py-3 px-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <Clock className="w-5 h-5 flex-shrink-0" />
            <div>
              <p className="font-semibold">Your trial has expired</p>
              <p className="text-sm text-white/90">
                Subscribe now to continue accessing all features
              </p>
            </div>
          </div>
          <Button
            onClick={() => navigate('/pricing')}
            className="bg-white text-red-600 hover:bg-red-50 flex-shrink-0"
          >
            <Crown className="w-4 h-4 mr-2" />
            View Plans
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={`${
      isExpiringSoon 
        ? 'bg-gradient-to-r from-orange-600 to-yellow-600' 
        : 'bg-gradient-to-r from-blue-600 to-purple-600'
    } text-white py-3 px-4`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Clock className="w-5 h-5 flex-shrink-0 animate-pulse" />
          <div>
            <p className="font-semibold">
              {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} left in your trial
            </p>
            <p className="text-sm text-white/90">
              Upgrade now to unlock all premium features
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => navigate('/pricing')}
            className="bg-white/20 hover:bg-white/30 backdrop-blur-sm border border-white/30 flex-shrink-0"
          >
            <Crown className="w-4 h-4 mr-2" />
            Upgrade Now
          </Button>
          {onClose && (
            <button
              onClick={onClose}
              className="text-white/80 hover:text-white p-2"
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
